import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./navbar";
import Footer from "./footer";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = window.sessionStorage.getItem("jwtToken");

const DiscountsCouponsManager = () => {
  const [allDiscounts, setAllDiscounts] = useState([]);
  const [editId, setEditId] = useState(null); // null means Add mode
  const [formData, setFormData] = useState({
    strategycode: "",
    couponcode: "",
    type: "DISCOUNT",
    status: "Inactive",
    preferred: 0,
    discount: 0,
    description: "",
    condition: "",
    combo: 0,
  });
  const [showForm, setShowForm] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();
  const [popupMessage, setPopupMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const userId = window.sessionStorage.getItem("userId");

  useEffect(() => {
    fetch(`${BASE_URL}/subscription-plan/{userId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((response) => {
        const coupons = response.data?.coupons || [];

        // If backend doesn't set type, infer it here
        const all = coupons.map((c) => ({
          ...c,
          type: c.type || (c.couponcode ? "COUPON" : "DISCOUNT"),
        }));

        setAllDiscounts(all);
      })
      .catch((err) => console.error("Error fetching:", err));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const endpoint = editId
        ? `${BASE_URL}/updateStrategyDiscount/${editId}`
        : `${BASE_URL}/saveStrategyDiscount`;

      const method = editId ? "PUT" : "POST";

      const res = await fetch(endpoint, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      if (!res.ok) throw new Error("Failed to save");
      const result = await res.json();

      if (editId) {
        // Update the entry in allDiscounts
        setAllDiscounts((prev) =>
          prev.map((item) =>
            item.id === editId ? { ...result, id: editId } : item,
          ),
        );
      } else {
        setAllDiscounts((prev) => [...prev, result]);
      }

      setFormData({
        strategycode: "",
        couponcode: "",
        type: "DISCOUNT",
        status: "Inactive",
        preferred: 0,
        discount: 0,
        description: "",
        condition: "",
        combo: 0,
      });
      setEditId(null);
      setShowForm(false);
      setPopupMessage(
        editId
          ? "Discount/Coupon updated successfully!"
          : "Discount/Coupon added successfully!",
      );
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
    } catch (err) {
      alert(err.message);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = allDiscounts.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(allDiscounts.length / itemsPerPage);

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid">
          <div
            className="d-flex justify-content-between mb-3"
            style={{ marginBottom: "10px", marginTop: "10px" }}
          >
            <button
              className="btn btn-primary  mb-3"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
            <h2 className="fw-bold">Discounts & Coupons Manager</h2>
            <button
              className="btn btn-primary mb-3"
              onClick={() => {
                setFormData({
                  strategycode: "",
                  couponcode: "",
                  type: "DISCOUNT",
                  status: "Inactive",
                  preferred: 0,
                  discount: 0,
                  description: "",
                  condition: "",
                  combo: 0,
                });
                setEditId(null); // ← Reset edit mode
                setShowForm(true);
              }}
            >
              Add Discount / Coupon
            </button>
          </div>

          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Strategy Code</th>
                  <th>Coupon Code</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Preferred</th>
                  <th>Discount</th>
                  <th>Description</th>
                  <th>Condition</th>
                  <th>Combo</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item, idx) => (
                  <tr key={idx}>
                    <td>{indexOfFirstItem + idx + 1}</td>
                    <td>{item.strategycode}</td>
                    <td>{item.couponcode}</td>
                    <td>{item.type}</td>
                    <td>{item.status}</td>
                    <td>{item.preferred}</td>
                    <td>{item.discount}</td>
                    <td>{item.description}</td>
                    <td>{item.condition}</td>
                    <td>{item.combo}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => {
                          setFormData(item);
                          setEditId(item.id); // ← Save id for editing
                          setShowForm(true);
                        }}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <nav className="d-flex justify-content-center mt-3">
              <ul className="pagination">
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                </li>
                {pageNumbers.map((number) => (
                  <li key={number} className="page-item">
                    <button
                      className={`page-link ${number === currentPage ? "active" : ""}`}
                      onClick={() => paginate(number)}
                    >
                      {number}
                    </button>
                  </li>
                ))}
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === pageNumbers.length}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>

          {showForm && (
            <div className="modal show" style={{ display: "block" }}>
              <div className="modal-dialog" style={{ margin: "auto" }}>
                <div
                  className="modal-content"
                  style={{ backgroundColor: "#e6e8ec" }}
                >
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {formData?.strategycode
                        ? "Edit Discount / Coupon"
                        : "Add Discount / Coupon"}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => {
                        setShowForm(false);
                        setFormData({
                          strategycode: "",
                          couponcode: "",
                          type: "DISCOUNT",
                          status: "Inactive",
                          preferred: 0,
                          discount: 0,
                          description: "",
                          condition: "",
                          combo: 0,
                        });
                      }}
                    ></button>
                  </div>
                  <form onSubmit={handleSave}>
                    <div className="modal-body">
                      {[
                        ["Strategy Code", "strategycode"],
                        ["Coupon Code", "couponcode"],
                        ["Type", "type", "select", ["DISCOUNT", "COUPON"]],
                        ["Status", "status", "select", ["Active", "Inactive"]],
                        ["Preferred", "preferred", "number"],
                        ["Discount", "discount", "number"],
                        ["Description", "description", "textarea"],
                        ["Condition", "condition", "textarea"],
                        ["Combo", "combo", "number"],
                      ].map(([label, name, type = "text", options]) => (
                        <div
                          key={name}
                          className="mb-3 d-flex align-items-center"
                        >
                          <label
                            className="form-label me-2"
                            style={{ minWidth: "180px" }}
                          >
                            {label}
                          </label>
                          <div className="flex-grow-1">
                            {type === "select" ? (
                              <select
                                className="form-select"
                                value={formData[name]}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    [name]: e.target.value,
                                  })
                                }
                                required
                              >
                                {options.map((opt) => (
                                  <option key={opt} value={opt}>
                                    {opt}
                                  </option>
                                ))}
                              </select>
                            ) : type === "textarea" ? (
                              <textarea
                                className="form-control"
                                value={formData[name]}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    [name]: e.target.value,
                                  })
                                }
                                required
                              />
                            ) : (
                              <input
                                type={type}
                                className="form-control"
                                value={formData[name]}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    [name]: e.target.value,
                                  })
                                }
                                required
                              />
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                          setShowForm(false);
                          setFormData({
                            strategycode: "",
                            couponcode: "",
                            type: "DISCOUNT",
                            status: "Inactive",
                            preferred: 0,
                            discount: 0,
                            description: "",
                            condition: "",
                            combo: 0,
                          });
                        }}
                      >
                        Close
                      </button>

                      <button type="submit" className="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}

          {showPopup && (
            <div className="modal" style={{ display: "block" }}>
              <div className="modal-dialog">
                <div className="modal-content">
                  <div
                    className="modal-header"
                    style={{ backgroundColor: "green" }}
                  >
                    <h5 className="modal-title">Success</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowPopup(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p>{popupMessage}</p>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => {
                        setShowPopup(false);
                        window.location.reload();
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DiscountsCouponsManager;
